import { useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { StockItemDefaultValuesType } from '../../entity';
import { useSuspenseStocksQuery, useCreateOrUpdateStockItemMutation } from '../../queries';

export const useStockItemForm = (defaultValues?: Partial<StockItemDefaultValuesType>) => {
  const [isPurchaseStockItem, setIsPurchaseStockItem] = useState(defaultValues ? false : true);
  const { data: stocks } = useSuspenseStocksQuery();
  const methods = useForm<StockItemDefaultValuesType>({
    defaultValues: {
      ...defaultValues,
    },
  });
  const { mutate: createOrUpdateStockItemMutation } = useCreateOrUpdateStockItemMutation({
    onSuccess: () => {
      methods.reset();
    },
  });

  const lastPackageQuantity = useWatch({ control: methods.control, name: 'lastPackageQuantity' });
  const unit = useWatch({ control: methods.control, name: 'unit' });
  const avgUnitPrice = useWatch({ control: methods.control, name: 'avgUnitPrice' });

  return {
    methods,
    stocks,
    isPurchaseStockItem,
    setIsPurchaseStockItem,
    stockItem: { avgUnitPrice, unit, lastPackageQuantity },
    createOrUpdateStockItemMutation,
  };
};
